/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minute: NonNullable<unknown> }} Agent_Schedule_Summary_HourlyInputs */



/**
* | output |
* | --- |
* | "Every hour, at {minute} past" |
*
* @param {Agent_Schedule_Summary_HourlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_summary_hourly = /** @type {((inputs: Agent_Schedule_Summary_HourlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Summary_HourlyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Stündlich, jeweils ${i?.minute} Minuten nach der vollen Stunde`)
	return /** @type {LocalizedString} */ (`Every hour, at ${i?.minute} past`)
});